(function() {
  'use strict';
  
  document.addEventListener("DOMContentLoaded", function () {
    const mobileFloatingButton = document.getElementById("FloatingAddToCartButton");
    const desktopFloatingButton = document.getElementById("DesktopFloatingAddToCartButton");
    const originalAddToCartButton = document.querySelector(".add-to-cart-btn");
    const shopSections = document.querySelectorAll(".shop-section-container");
  
    // Function to check if an element is in the viewport
    function isElementInViewport(el) {
      if (!el) return false; // Return false if element doesn't exist
      const rect = el.getBoundingClientRect();
      return rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0;
    }
  
    // Function to toggle the visibility of the floating buttons
    function toggleFloatingButtonVisibility() {
      const isMobile = window.innerWidth < 768;
      let anySectionInView = false;
  
      // Check if any shop section is in the viewport
      shopSections.forEach(section => {
        if (isElementInViewport(section)) {
          anySectionInView = true;
        }
      });
  
      if (anySectionInView) {
        // Hide floating buttons if any shop section is visible
        mobileFloatingButton.style.opacity = "0";
        desktopFloatingButton.style.opacity = "0";
        mobileFloatingButton.style.pointerEvents = "none";
        desktopFloatingButton.style.pointerEvents = "none";
      } else {
        // Show floating buttons based on device type
        if (isMobile) {
          mobileFloatingButton.style.opacity = "1";
          desktopFloatingButton.style.opacity = "0";
          mobileFloatingButton.style.pointerEvents = "auto";
          desktopFloatingButton.style.pointerEvents = "none";
        } else {
          mobileFloatingButton.style.opacity = "0";
          desktopFloatingButton.style.opacity = "1";
          mobileFloatingButton.style.pointerEvents = "none";
          desktopFloatingButton.style.pointerEvents = "auto";
        }
      }
    }
  
    // Attach scroll and resize events
    window.addEventListener("scroll", toggleFloatingButtonVisibility);
    window.addEventListener("resize", toggleFloatingButtonVisibility);
    toggleFloatingButtonVisibility(); // Initial check on page load
  
    // Link the floating buttons to the Add to Cart form submission
    [mobileFloatingButton, desktopFloatingButton].forEach(button => {
      button.addEventListener("click", function () {
        // Scroll to the Add to Cart button of the first shop section
        const shopSection1 = document.querySelector(".shop-section-container");
        if (shopSection1) {
          shopSection1.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  });
})();
